var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 141,
    viewBox: "0 0 140 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M112.273 38.8994C111.343 39.2311 110.362 39.3976 109.375 39.3916C107.054 39.3916 104.829 38.4697 103.188 36.8288C101.547 35.1879 100.625 32.9623 100.625 30.6416C100.619 29.6542 100.785 28.6733 101.117 27.7432C90.2617 19.7478 76.7464 16.235 63.3716 17.9327C49.9969 19.6304 37.7879 26.4084 29.2743 36.8623C20.7607 47.3163 16.5951 60.6448 17.6407 74.0863C18.6862 87.5278 24.8628 100.052 34.8905 109.063C38.1827 102.58 43.2056 97.1357 49.4027 93.3325C55.5998 89.5293 62.7289 87.5163 69.9999 87.5166C65.6734 87.5166 61.4441 86.2337 57.8468 83.83C54.2495 81.4264 51.4457 78.01 49.79 74.0128C48.1344 70.0157 47.7012 65.6174 48.5452 61.374C49.3893 57.1307 51.4727 53.2329 54.5319 50.1737C57.5912 47.1144 61.489 45.031 65.7323 44.1869C69.9756 43.3429 74.374 43.7761 78.3711 45.4318C82.3682 47.0874 85.7846 49.8912 88.1883 53.4885C90.5919 57.0858 91.8749 61.3152 91.8749 65.6416C91.8749 71.4432 89.5702 77.0072 85.4678 81.1096C81.3655 85.2119 75.8015 87.5166 69.9999 87.5166C77.2709 87.5163 84.4 89.5293 90.5971 93.3325C96.7941 97.1357 101.817 102.58 105.109 109.063C114.802 100.345 120.904 88.3327 122.228 75.3636C123.552 62.3945 120.004 49.3967 112.273 38.8994Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 87.5168C82.0812 87.5168 91.875 77.7231 91.875 65.6418C91.875 53.5606 82.0812 43.7668 70 43.7668C57.9188 43.7668 48.125 53.5606 48.125 65.6418C48.125 77.7231 57.9188 87.5168 70 87.5168Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8905 109.064C38.1822 102.58 43.205 97.1346 49.4021 93.3308C55.5992 89.527 62.7285 87.5135 69.9999 87.5135C77.2713 87.5135 84.4006 89.527 90.5977 93.3308C96.7948 97.1346 101.818 102.58 105.109 109.064",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.375 39.3918C114.207 39.3918 118.125 35.4743 118.125 30.6418C118.125 25.8094 114.207 21.8918 109.375 21.8918C104.543 21.8918 100.625 25.8094 100.625 30.6418C100.625 35.4743 104.543 39.3918 109.375 39.3918Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.375 21.8918V15.3293",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.773 26.2668L96.1405 22.9856",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.773 35.0168L96.1405 38.2981",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.375 39.3918V45.9543",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M116.977 35.0168L122.61 38.2981",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M116.977 26.2668L122.61 22.9856",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M122.117 63.7276C122.382 65.8133 122.51 67.9142 122.5 70.0167C122.5 80.4002 119.421 90.5505 113.652 99.1841C107.883 107.818 99.684 114.547 90.0909 118.52C80.4978 122.494 69.9418 123.534 59.7578 121.508C49.5738 119.482 40.2191 114.482 32.8769 107.14C25.5346 99.7975 20.5345 90.4429 18.5088 80.2589C16.483 70.0749 17.5227 59.5189 21.4963 49.9258C25.4699 40.3327 32.199 32.1333 40.8326 26.3645C49.4661 20.5958 59.6165 17.5167 70 17.5167C71.6251 17.5064 73.2496 17.5795 74.8672 17.7354",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.adc88cd5a8fc94b404fa2b942af1b39b.svg";
export { ForwardRef as ReactComponent };